import { render, staticRenderFns } from "./PublishingStatementsRoyaltyControllingDialog.vue?vue&type=template&id=40a77904"
import script from "./PublishingStatementsRoyaltyControllingDialog.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsRoyaltyControllingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports